import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import { useContentTheme } from './content-theme';

const PagebuilderContent = ({
  className,
  textAlign,
  content,
  ...props
}) => {
  const { contentTheme } = useContentTheme();
  return (
    <Content
      className={className}
      $textAlign={textAlign}
      $content={content}
      $contentTheme={contentTheme}
      {...props}
    />
  );
};

export default styled(PagebuilderContent)``;
